import { Box, Text, useColorModeValue } from '@chakra-ui/react';

function Footer() {
  const color = useColorModeValue('gray.500', 'gray.400');
  return (
    <Box as="footer" py={8} px={8}>
      <Box textAlign="center">
        <Text fontSize="sm" color={color} mb={2}>
          © {new Date().getFullYear()} Splunk Sizing Calculator
        </Text>
        <Text fontSize="sm" color={color}>
          Desenvolvido por{' '}
          <Box as="a" href="https://www.datarunk.com" target="_blank" rel="noopener noreferrer" color="brand.500" fontWeight="bold" _hover={{ textDecoration: 'underline' }}>
            DataRunk
          </Box>
          {' '}| Inteligência em Cibersegurança
        </Text>
      </Box>
    </Box>
  );
}

export default Footer;
